import request from '../utils/request'

/**
 * 更新机构次数
 * @param data 
 * @returns 
 */

export function getNumApi(data: any) {
    return request({
        url: 'aippt/update',
        method: 'post',
        data: data
    })
}
/**
 * 获取code
 * @returns 
 */
export function getCodeApi() {
    return request({
        url: 'aippt/get_authcode',
        method: 'post',
    })
}
/**
 * 获取机构次数
 * @returns 
 */
export function getTimesApi() {
    return request({
        url: 'aippt/select',
        method: 'post',
    })
}

/**
 * 登录
 * @param data 
 * @returns 
 */
export function loginAccountApi (data: any) {
    return request({
        url: 'personlogin/',
        method: 'post',
        data: data
    })
}

/**
 * 获取邮箱验证码
 * @param email 
 * @returns 
 */
export function getEmailCodeApi(email:any) {
    return request({
        url: '/forgetpassword/',
        method: 'get',
        params:{
            email
        }
    })
}

/**
 * 找回密码
 * @param data 
 * @returns 
 */
export function forgetpasswordApi(data:any) {
    return request({
        url: '/forgetpassword/',
        method: 'post',
        data
    })
}

/**
 * 行为埋点
 */
export function behaviorApi(data:any) {
    return request({
        url: '/aippt/track',
        method: 'post',
        data: {
            platform: 'AiPPT',
            event: data.event,
            params: data.params
        }
    })
}

/**
 * 获取作品数量
 */
export function getWorksNumApi(type:any) {
    return request({
        url: '/aippt/get_total?is_intl=' + type,
        method: 'get',
    })
}